import * as answer from './answer';
import * as contentSuggestion from './contentSuggestion';
import * as expertRelay from './expertRelay';
import * as mentorInquiry from './mentorInquiry';
import * as modInquiry from './modInquiry';
import * as primumSupport from './primumSupport';
import * as reference from './reference';
import * as supportMessage from './supportMessage';

/**
 * The registration point for chat message types.
 *
 * Listing a per-type module here is the whole registration: the schemas
 * (`catalog.ts`) and the inbox behavior map (`behavior.ts`) are both derived
 * from this array, so neither has a hand-maintained member list that can drift
 * out of sync with the modules.
 *
 * This module is kept free of everything but the per-type modules themselves.
 * `behavior.ts` needs only the discriminators, and the inbox handlers reach it
 * through there — routing them via `catalog.ts` instead would make every
 * consumer of a message type's behavior transitively load the chat-bubble
 * stores that `catalog.ts` folds into the read path.
 *
 * LANDMINE: two modules whose `attributesSchema` declare the same field name
 * with *different* types would merge silently at runtime (last wins) while the
 * type-level fold in `catalog.ts` degrades — and the cast there suppresses the
 * error that would otherwise surface it. `approved` is already declared twice
 * today (identically, so benign). Keep field names disjoint across types unless
 * the types match exactly.
 */
export const MESSAGE_TYPE_MODULES = [
  reference,
  answer,
  primumSupport,
  expertRelay,
  modInquiry,
  mentorInquiry,
  contentSuggestion,
  supportMessage,
] as const;

export type MessageTypeModules = typeof MESSAGE_TYPE_MODULES;
